import { Grid } from "@material-ui/core";
import React from "react";

import { CmsRenderContentMapper } from "../content/CmsRenderContentMapper";
import { CmsRenderLayoutProps } from "./CmsRenderLayoutProps";

export function CmsRenderLayoutOneOne({ section }: CmsRenderLayoutProps) {
    return (
        <>
            <Grid item xs={6}>
                <CmsRenderContentMapper content={section.content[0]} />
            </Grid>
            <Grid item xs={6}>
                <CmsRenderContentMapper content={section.content[1]} />
            </Grid>
        </>
    );
}
